import * as React from "react";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export default class Stats extends React.Component<any, any> {
    viewsSales: any;
    productsSales: any;
    usersSales: any;
  constructor(props: any) {
    super(props);
    this.state = {
      startDate: moment().subtract(7, "days"),
      endDate: moment(),
      campaignUrl: this.props.campaign?.url,
      timeoutId: null,
    };
  }


  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    if(prevProps.campaign?.url !== this.props.campaign?.url) {
      this.setState({campaignUrl: this.props.campaign?.url})
    }
  }

  componentDidMount() {
    this.loadChart()

  }

  
  handleDateChange = (date: any) => {

  }

  loadChart = () => {
    window.Chart.defaults.color = "#12408d";
    window.Chart.defaults.font.size = 14;
    window.Chart.defaults.font.family = "Heebo";
    new window.Chart(this.viewsSales.getContext('2d'), {
        type: 'line',
        data: {
            labels: [],
            datasets: []
        },
        options: {
          responsive: false,
          plugins: {
            title: {
              display: true,
              text: "מכירות לאורך זמן"
            }
          },
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }
    });
    new window.Chart(this.productsSales.getContext('2d'), {
      type: 'pie',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: false,
        plugins: {
          legend: {
            position: "right",
            maxWidth: 300
          },
          title: {
            display: true,
            text: "מכירות לפי מוצר"
          }
        },
      }
    });
    new window.Chart(this.usersSales.getContext('2d'), {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: false,
          scales: {
              y: {
                  beginAtZero: true
              }
          }
          ,
        plugins: {
          legend: {display: false},
          title: {
            display: true,
            text: "מכירות לפי משפיען"
          }
        },
      }
    });
  }

  handleInputChange = (event:any) => {
    clearTimeout(this.state.timeoutId);
    const inputValue = event.target.value;
    this.setState({
      campaignUrl: inputValue,
      timeoutId: setTimeout(() => {
        // Send request to the server to save the input
        fetch(`campaigns/edit`, {
          method: "POST",
          body: JSON.stringify({
            id: this.props.campaign?.id,
            url: inputValue
          })
        })
          .then((results) => {
            return results.json();
          })
          .then((data) => {
            this.setState({ campaign: data.campaign });
          })
          .catch((err) => {
            //toast.error(err.message);
          });

      }, 500),
    });
  };




  public render() {
    const {campaign} = this.props
    return (
        <div className="board">
          <div className="campaign-box">
            <label>לינק לאתר הקמפיין</label>
            <input className="campaignLink white-box" value={this.state.campaignUrl} onChange={this.handleInputChange}  />
          </div>
          <div className="campaign-box dates">
              <label>טווח תאריכים</label>
              <span>מ-</span>
              <DatePicker
                selected={moment(this.state.startDate, "MM/DD/YYYY").toDate()}
                onChange={() => {this.handleDateChange("startDate")}}
                autoComplete="disable_autocomplete"
                dateFormat="dd/MM/yyyy"
              />
              <span>עד-</span>
              <DatePicker
                selected={moment(this.state.endDate, "MM/DD/YYYY").toDate()}
                onChange={() => {this.handleDateChange("endDate")}}
                autoComplete="disable_autocomplete"
                dateFormat="dd/MM/yyyy"
              />
          </div>
          <div className="totals">
            <div className="total white-box">
            <span>מכירות</span>
            <i className="fas fa-coins"></i>
            ₪{campaign?.total || 0}
            </div>
            <div className="total white-box">
            <span>קליקים</span>
             <i className="fas fa-mouse-pointer"></i>
              {campaign?.clicks || 0}
            </div>
            <div className="total white-box">
            <span>כניסות</span>
              <i className="fas fa-eye"></i>
              {campaign?.views || 0}
            </div>
            <div className="total white-box">
            <span>זמן צפיה ממוצע בדקות</span>
            <i className="fas fa-clock"></i>
              {campaign?.minutes || 0}
            </div>
          </div>
          <div className="graphs-view">
            <div className="white-box" style={{display: "inline-block", padding: "20px", margin: "25px 0"}}><canvas className="big" ref={(el) => {this.viewsSales = el}}></canvas></div>
            <div className="white-box" style={{display: "inline-block", padding: "20px" , margin: "25px 0"}}><canvas className="big" ref={(el) => {this.usersSales = el}}></canvas></div>
            <div className="white-box" style={{display: "inline-block", padding: "20px" , margin: "25px 0"}}><canvas className="big" ref={(el) => {this.productsSales = el}}></canvas></div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/Stats.tsx